import axios from 'axios'
import {createAsyncThunk, createAction} from '@reduxjs/toolkit'
import { sliceStateStatus } from '../../../../Core';
import {routesIndex} from '@/RoutesIndex';

import ISearch from '@/interface/core/ISearch';
import ISliceState from '@/interface/core/ISliceState';
import IMember from '@/interface/IMember';
import { generateMemberStateDataItem, generatePaginationStateDataItem } from '@/redux/hooks';
import IPagination from '@/interface/core/IPagination';
import { IType } from '@/interface/IType';

export const searchInvoke = createAsyncThunk(
  'search',
  async (_data: ISearch, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      };

      let uri = routesIndex.api.prefix + routesIndex.api.search

      if(_data!.page && parseInt(_data!.page) > 1) {
        uri += '?page='+_data!.page;
      }

      const q = axios.post(
        uri, 
        _data,
        config
      );
      const r = (await q).data;

      const b = setStateData(r, true)
      
      return {
        ...b, 
        ids: r.ids,
        params: _data,
        emailcount: r.emailcount,
        sentcount: r.sentcount,
      };

    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


export const setSearchData = createAction<ISearch>('setSearchData')
export const removeSearchData = createAction('removeSearchData')

export const setSearchParams = createAction<ISearch>('setSearchParams')
export const removeSearchParams = createAction('removeSearchParams')

const setStateData = (apiResponse: any, paginate: boolean = false) => {

  let stateData: ISliceState = {
    data: new Array<IMember>(),
    status: sliceStateStatus.fulfilled
  };

  if(apiResponse.status && apiResponse.result) {

    if(paginate) {
      stateData.data = {} as IPagination;
      Object.assign(stateData.data, generatePaginationStateDataItem(apiResponse.result, IType.member));
    }
    else {
      if(Array.isArray(apiResponse.result)) {
        apiResponse.result.map((a: any, i: number) => (
          stateData.data.push(
            generateMemberStateDataItem(a)
          )
        ))
      }
      else {
        stateData.data = {} as IMember;
        Object.assign(stateData.data, generateMemberStateDataItem(apiResponse.result));
      } 
    }
  }
  
  return stateData;
};